export const MENTION_TRIGGER = '@';
export const PAGE_MENTION_ENTITY_TYPE = 'PAGE_MENTION';

export const KEY_BINDING_MAP = {
  ENTER: 'ENTER',
  ESC: 'ESC',
  ARROW_UP: 'ARROW_UP',
  ARROW_DOWN: 'ARROW_DOWN',
};

export const mentionSuggestionsElementId = 'mentionSuggestionsElementId';

export const EDITOR_TYPES = {
  DETAILS: 'DETAILS',
  ACCOMMODATION: 'ACCOMMODATION',
};
